export default (filters, stateFilters) => {
	let newFilters;

	if (_.isEmpty(stateFilters)) {
		newFilters = {
			filterTypes: {...stateFilters}
		};
	} else {
		newFilters = {...stateFilters};

		if (_.isEmpty(newFilters.filterTypes)) {
			newFilters.filterTypes = {};
		}
	}

	if (filters.filterItemName) {
		newFilters.filterTypes[filters.filterItemName] = filters.value;
	}

	return newFilters;
};
